import yup from 'src/libs/yup';

export default yup.object().shape({
  email: yup.string().email().required().label('E-mail'),
});
